import { useBalanceHistoryQuery } from "@RTKQuery/user/balance/balance";
import style from "./TableBody.module.scss";
import { IHistoryRecord } from "@interfaces/user/historyRecord";

export function TableBody({
    children
}: {
    children: (data: IHistoryRecord) => JSX.Element
}) {
    const {data} = useBalanceHistoryQuery();

    return (
        <div className={style.body}>
            {
                data?.map(row => children(row))
            }
        </div>
    )
}

